export default {
    mounted(el, binding, vnode, prevVnode) {
        var sticky = el.offsetTop;
        var cssClass = binding.value.class;
        el.scrollEvent = function () {
            if (window.pageYOffset >= sticky) {
                el.classList.add(cssClass);
            }
            else {
                el.classList.remove(cssClass);
            }
        };
        document.addEventListener('scroll', el.scrollEvent);
    }
};
